export const Events = {
  SPACE_CLICK: 'SPACE_CLICK',

  SPACE_HOVER: 'SPACE_HOVER',

  SPACE_DETAILS: 'SPACE_DETAILS',

  SHOW_SPACE_HOVER_TOGGLE: 'SHOW_SPACE_HOVER_TOGGLE',

  FLOOR_CHANGE: 'FLOOR_CHANGE',

  BUILDING_CHANGE: 'BUILDING_CHANGE',

  SPACE_PUT_HOLD: 'SPACE_PUT_HOLD',

  SPACE_CLICK_CANCEL_HOLD: 'SPACE_CLICK_CANCEL_HOLD',

  SPACE_UPDATE_HOLD: 'SPACE_UPDATE_HOLD',

  SPACE_MULTI_HOLD: 'SPACE_MULTI_HOLD',

  SPACE_OPEN_PUT_ON_HOLD_FORM: 'SPACE_OPEN_PUT_ON_HOLD_FORM',

  SPACE_REMOVE_HOLD: 'SPACE_REMOVE_HOLD',

  SPACE_CLICK_ADD_OFFICE_NOTE: 'SPACE_CLICK_ADD_OFFICE_NOTE',

  SPACE_CLICK_UPDATE_OFFICE_NOTE: 'SPACE_CLICK_UPDATE_OFFICE_NOTE',

  SPACE_REMOVE_OFFICE_NOTE: 'SPACE_REMOVE_OFFICE_NOTE',

  SPACE_UPDATE_OFFICE_NOTE: 'SPACE_UPDATE_OFFICE_NOTE',

  SPACE_CLOSE_OFFICE_NOTE_MODAL: 'SPACE_CLOSE_OFFICE_NOTE_MODAL',

  SPACE_ADD_OFFICE_NOTE: 'SPACE_ADD_OFFICE_NOTE',

  FILTER: 'FILTER',

  VIEW_DESK_LAYOUT: 'VIEW_DESK_LAYOUT',

  VIEW_SPACE_LIST: 'VIEW_SPACE_LIST',

  VIEW_SPACE_LABELS: 'VIEW_SPACE_LABELS',

  VIEW_SPACE_OCCUPANCY: 'VIEW_SPACE_OCCUPANCY',

  VIEW_USER_GUIDE: 'VIEW_USER_GUIDE',

  VIEW_VIDEO_LINK: 'VIEW_VIDEO_LINK',

  VIEW_SURVEY: 'VIEW_SURVEY',

  TOGGLE_SELECT_TOOL: 'TOGGLE_SELECT_TOOL',

  ONBOARDING_ITEM_CLICK: 'ONBOARDING_ITEM_CLICK',

  ONBOARDING_STEPS_FINISH: 'ONBOARDING_STEPS_FINISH',

  VIEW_BUILDING_INFO: 'VIEW_BUILDING_INFO',

  SEARCH_KEYWORD_CHANGE: 'SEARCH_KEYWORD_CHANGE',

  ADD_FILTER: 'ADD_FILTER',

  // '- Map: Toggle Legend show', // x
  TOGGLE_LEGEND_SHOW: 'TOGGLE_LEGEND_SHOW',

  // '- Map: Toggle Legend hide', // x
  TOGGLE_LEGEND_HIDE: 'TOGGLE_LEGEND_HIDE',

  // '- Map: Reset Camera', // x
  RESET_CAMERA: 'RESET_CAMERA',

  // '- Map: Rotate Map by 90 ', // x
  ROTATE_MAP_CLOCKWISE: 'ROTATE_MAP_CLOCKWISE',

  // '- Map: Rotate Map by -90 ', // x
  ROTATE_MAP_ANTI_CLOCKWISE: 'ROTATE_MAP_ANTI_CLOCKWISE',

  OCCUPANCY_MAP_LEAVE: 'OCCUPANCY_MAP_LEAVE',

  OCCUPANCY_MAP_IMPRESSION: 'OCCUPANCY_MAP_IMPRESSION',

  BUILDING_LOADED: 'BUILDING_LOADED',

  CLICK_APP_BAR_FILTERS: 'CLICK_APP_BAR_FILTERS',

  CLICK_APP_BAR_VIEWS: 'CLICK_APP_BAR_VIEWS',

  CLICK_APP_BAR_SELECT: 'CLICK_APP_BAR_SELECT',
}
